import React, { useEffect } from "react";

declare global {
  interface Window {
    startAnymindTS: () => void;
    anymindTS: {
      dispose: () => void;
    };
    gtag: (
      event: string,
      page_view: string,
      parameters: { [key: string]: any }
    ) => void;
  }
}

// Set to true to re-enable ATS ads
const ATS_ENABLED = false;

const AdPage: React.FC = () => {
  useEffect(() => {
    // 初始化 Google Analytics 页面视图
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: window.location.pathname,
        page_title: document.title,
      });
      console.log("GA4 Page View Logged!");
    }

    if (!ATS_ENABLED) {
      return;
    }

    // 在组件挂载后启动 ATS
    try {
      if (window.startAnymindTS) {
        window.startAnymindTS();
        console.log("ATS Initialized!");
      }
    } catch (e) {
      console.error("Error initializing ATS:", e);
    }

    // 在组件卸载时清理 ATS
    return () => {
      if (window.anymindTS && window.anymindTS.dispose) {
        window.anymindTS.dispose();
        console.log("ATS Disposed!");
      }
    };
  }, []); // 空依赖数组确保只在挂载和卸载时运行

  if (!ATS_ENABLED) {
    return null;
  }

  return (
    <div className="flex flex-col items-center">
      {/* 广告容器，ATS 会将广告注入到此元素中 */}
      <div
        id="ad_sample"
        className="flex justify-center items-center w-full py-0 bg-transparent"
      >
        {/* Advertisement Container */}
      </div>
    </div>
  );
};

export default AdPage;
